import { StyledHeader, MenuBlock, UserInfo, AvatarStyle} from './styles';
import { Dropdown, type MenuProps } from 'antd';
import { HiUser } from "react-icons/hi2";
import { TbBellFilled } from "react-icons/tb";
import { getCurrentTimestamp } from '@/utils';
import { useAuthInfo, useSignOut } from '@/features';

export function Header() {
  const { authInfo } = useAuthInfo();
  const { signOut } = useSignOut();
  const client_id = authInfo?.nickname;
  const historyTime = getCurrentTimestamp();
  const dropdownItems: MenuProps['items'] = [
    {
      label: '로그아웃',
      key: 'signOut',
      onClick: () => handleDropdownClick(),
    },
  ];
  const handleDropdownClick = () => {
    signOut();
  };
  
  return (
    <StyledHeader>
      <MenuBlock>
        <p>최근 접속일시</p>
        <p>{historyTime}</p>
      </MenuBlock>
      <UserInfo>
        {client_id} 님
        <TbBellFilled style={{fontSize: 19}} />
        <Dropdown menu={{ items: dropdownItems }}>
          <AvatarStyle icon={<HiUser style={{color: 'rgba(151, 151, 153, 1)', fontSize: '24px', marginBottom: -2}}/>} />
        </Dropdown>
      </UserInfo>
    </StyledHeader>
  );
}
